import { fetch_sadap } from '../../../../core/api';

const getReportTypeByName = (name) => {
    return fetch_sadap(`report/report-type/detail?name=${name}`, "get", false)
}

export const GetReportTypeByName = (name) => {
    return fetch_sadap(`report/report-type/detail?name=${name}`, "get", false)
}

export default getReportTypeByName;